<template>
  <div class="orderState boxs" v-if="order_base" ref="orderStateDiv">
    <vue-scroll :ops="ops" ref="vs">
      <div class="state-tit boxs"><b>订单编号：</b>{{order_base.order_id}}</div>
      <!-- 订单状态 -->
      <div class="stateWrap boxs">
        <p class="state">订单状态：
          <span v-if="order_base.status_code == 1">待支付</span>
          <span v-if="order_base.status_code == 2">待取卡</span>
          <span v-if="order_base.status_code == 4" class="black">已完成</span>
          <span v-if="order_base.status_code == 5" class="black">已关闭</span>
          <span v-if="order_base.status_code == 7" class="black">已取消</span>
        </p>
      </div>

      <!-- 状态内容-待支付 -->
      <div class="sateCon" v-if="order_base.status_code  == 1">
        <p class="conText">若客户未在规定时间内完成付款，则订单按照设置时间逾期自动关闭。</p>
        <div class="btnWrap">
          <button @click="toggleLayer(4)" class="butStyle stateBtn orangeBtn">修改价格</button>
          <button @click="toggleLayer(2)" class="butStyle stateBtn pinkBtn">关闭订单</button>
          <button @click="toggleLayer(5)" class="butStyle stateBtn whiteBtn">备注</button>
        </div>
      </div>

      <!-- 状态内容-待取卡 -->
      <div class="sateCon" v-if="order_base.status_code  == 2">
        <p class="conText">客户已付款，待客户取卡。</p>
        <div class="btnWrap">
          <button @click="toggleLayer(5)" class="butStyle stateBtn whiteBtn">备注</button>
        </div>
      </div>

      <!-- 状态内容-已完成 -->
      <div class="sateCon" v-if="order_base.status_code == 4">
        <p class="conText">客户已确认收货，订单完成。若订单无误，在24小时后系统自动关闭订单。</p>
        <div class="btnWrap">
          <button @click="toggleLayer(2)" class="butStyle stateBtn pinkBtn">关闭订单</button>
          <button @click="toggleLayer(5)" class="butStyle stateBtn whiteBtn">备注</button>
        </div>
      </div>

      <!-- 状态内容-已关闭 -->
      <div class="sateCon" v-if="order_base.status_code == 5">
        <p class="conText">订单已关闭</p>
        <button @click="toggleLayer(5)" class="butStyle stateBtn whiteBtn">备注</button>
      </div>

      <!-- 状态内容-已取消 -->
      <div class="sateCon" v-if="order_base.status_code == 7">
        <p class="conText">订单已取消</p>
        <button @click="toggleLayer(5)" class="butStyle stateBtn whiteBtn">备注</button>
      </div>

      <!-- 备注 -->
      <p class="remasks boxs" :style="{width:fullWidth}">{{order_base.note || '暂无备注信息'}}</p>

    </vue-scroll>

    <!-- 发货 -->
    <send @cancel="showSend = false"
          @confirm="handleSendConfirm"
          :order-item="order"
          v-if="showSend">
    </send>

    <!--关闭订单-->
    <close-order
            @cancel="showCloseOrder = false"
            @confirm="handleCloseOrderConfirm"
            v-if="showCloseOrder">
    </close-order>

    <!-- 延迟收货时间 -->
    <delay-time
            @cancel="showDelayTime = false"
            @confirm="handleDelayTimeConfirm"
            v-if="showDelayTime">
    </delay-time>

    <!-- 修改价格 -->
    <up-data-price @confirm="handleUpdatePriceConfirm"
                   @cancel="showUpdatePrice = false"
                   v-if="showUpdatePrice">
    </up-data-price>

    <!-- 修改备注 -->
    <base-prompt-box @confirm="handleUpdateNote"
                     @cancel="showUpdateNote = false"
                     :title='"备注"'
                     :placeholder='"请输入备注信息"'
                     v-if="showUpdateNote">
    </base-prompt-box>

    <!-- 修改物流 -->
    <update-logistics @confirm="handleUpdateLogistics"
                      @cancel="showUpdateLogistics = false"
                      :order-item="order_base"
                      v-if="showUpdateLogistics">
    </update-logistics>
  </div>
</template>

<script>

  import BasePromptBox from '@/components/Common/BasePromptBox/BasePromptBox';
  import {yuanToCents, centsToYuan} from '@/utils/unitConverter.js';
  import {
    getOrderListReq,
    deliverGoodsReq,
    closeOrderReq,
    extendReceiptTimeReq,
    modifyPriceReq,
    updateLogisticsReq,
    updateNoteReq,
  } from "@/api/Order/NumCardOrder/internetBuyCardOrder.js";
  import {calDiff} from '@/utils/dateFormatter.js';
  import closeOrder from '@/views/Order/Common/CloseOrder';
  import delayTime from '@/views/Order/Common/DelayTime';
  import upDataPrice from '@/views/Order/Common/UpDataPrice';
  import UpdateLogistics from '@/views/Order/Common/UpdateLogistics';
  import send from '@/views/Order/Common/Send';

  export default {
    name: "orderState", //现场自取
    props: {
      orderItem: {
        required: true,
        type: Object
      }
    },
    data() {
      return {
        fullWidth: '', //备注信息的显示宽度
        order_base: this.orderItem.order_base,
        expires: {
          days: '',
          minutes: '',
          hours: ''
        },
        showSend: false,
        showUpdatePrice: false,
        showDelayTime: false,
        showCloseOrder: false,
        showUpdateNote: false,
        showUpdateLogistics: false,
        order: {},
        ops: {
            scrollPanel: {
                padding: true
            },
            rail: {
                background: '#fff',
                opacity: 1,
                gutterOfSide: 0,
                size: '8px'
            },
            bar: {
                keepShow: true,
                background: '#ddd',
                size: '5px'
            },
        },//滚动条配置
      }
    },
    created() {
      // console.log(this.order_base)
      // 第一次进入页面时，获取当前template的宽度
      this.initGetWidth();
    },
    watch: {
      orderItem(val) {
        this.order_base = val.order_base
        this.expires = calDiff(this.order_base.progress_expires)
        this.order = {
          skus: val.order_skus,
          order_id: val.order_base.order_id
        }
      }
    },
    mounted() {
      // 屏幕宽度变化时，获取当前template的宽度
      const that = this
      that.initGetWidth();
      window.onresize = () => {
        return (() => {
          that.fullWidth = that.$refs.orderStateDiv.clientWidth-9 + 'px';
          // console.log(that.fullWidth)
        })()
      }
    },
    methods: {
      // 第一次进入页面时，获取当前template的宽度
      initGetWidth() {
        let _this = this
        this.$nextTick(() =>{
          _this.fullWidth = _this.$refs.orderStateDiv.clientWidth-9 + 'px';
        // console.log('this.fullWidth', this.fullWidth)
        })
      },
      // 修改价格回调事件
      handleUpdatePriceConfirm(result) {
        // 数据清洗，过滤无用的请求数据
        const req_skus = result.skus.map(value => {
          return {
            id: value.sku_id,
            price_real: yuanToCents(value.price_real)
          }
        })

        const req = {
          order_skus: req_skus,
          order_id: this.order.order_id,
        }
        modifyPriceReq(req)
            .then(resp => {
              this.$notifySuccess(`订单[${this.order.order_id}]价格修改成功`);
            })
            .catch(e => console.log(e))
      },
      // 修改备注
      handleUpdateNote(result) {
        // 数据清洗，过滤无用的请求数据
        const req = {
          note: result.value,
          order_id: this.order.order_id,
        }
        updateNoteReq(req)
            .then(resp => {
              this.toggleLayer(5)
              this.reloadPage()
            })
            .catch(e => console.log(e))
      },
      // 修改物流信息
      handleUpdateLogistics(val) {
        // 数据清洗，过滤无用的请求数据
        const p = {
          order_id: this.order.order_id,
          express_type: val.express_type,
          express_num: val.express_num
        }
        updateLogisticsReq(p)
            .then(resp => {
              this.toggleLayer(6)
              this.reloadPage()
            })
            .catch(e => console.log(e))
      },
      reloadPage() {
        this.$router.go(0)
      },
      // 处理发货确认事件
      handleSendConfirm(val) {
        if (val.needLogistics == 1) {
          if (!val.express_type) {
            this.$notifyError('请选择一家物流公司');
            return;
          }
          if (!val.express_num) {
            this.$notifyError('请输入物流单号');
            return;
          }
        }

        const p = {
          order_id: val.order_id,
          express_type: val.express_type,
          express_num: val.express_num
        }
        deliverGoodsReq(p)
            .then(resp => {
              this.toggleLayer(1)
              this.reloadPage()
            })
            .catch(e => console.log(e))
      },
      // 处理延长收货时间确认事件
      handleDelayTimeConfirm() {
        const p = {
          order_id: this.order_base.order_id,
        }
        extendReceiptTimeReq(p)
            .then(resp => {
              this.toggleLayer(3)
              this.reloadPage()
            })
            .catch(e => console.log(e))
      },
      // 处理关闭订单确认事件
      handleCloseOrderConfirm(close_reason) {
        const p = {
          order_id: this.order_base.order_id,
          close_reason: close_reason
        }
        closeOrderReq(p)
            .then(resp => {
              this.toggleLayer(2)
              this.reloadPage()
            })
            .catch(e => console.log(e))
      },
      // 弹层开关
      toggleLayer(type, item) {
        // 1：发货 2:关闭订单 3：延长发货时间 4：更新价格 5.备注 6:修改物流
        switch (type) {
          case 1:
            this.showSend = !this.showSend
            break;
          case 2:
            this.showCloseOrder = !this.showCloseOrder
            break;
          case 3:
            this.showDelayTime = !this.showDelayTime
            break;
          case 4:
            this.showUpdatePrice = !this.showUpdatePrice
            break;
          case 5:
            this.showUpdateNote = !this.showUpdateNote
            break;
          case 6:
            this.showUpdateLogistics = !this.showUpdateLogistics
            break;
        }
      },
    },
    components: {
      closeOrder,
      delayTime,
      upDataPrice,
      send,
      BasePromptBox,
      UpdateLogistics
    }
  }
</script>

<style scoped>
  .orderState {
    width: 27%;
    min-width: 300px;
    height: 240px;
    background: #fff;
    font-size: 12px;
  }

  /* 标题 */
  .orderState .state-tit {
    line-height: 36px;
    height: 36px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding:0 12px;
  }

  /*  订单状态 */
  .orderState .stateWrap {
    margin-top: 15px;
    padding:0 12px;
  }

  .stateWrap .state {
    font-size: 13px;
    font-weight: bold;
    color: #333;
  }

  .stateWrap .state > span {
    color: #DF0000;
  }

  .stateWrap .state > span.green {
    color: #2DBAA5;
  }

  .stateWrap .state > span.black {
    color: #333333;
  }

  /* 状态内容 */
  .sateCon {
    margin-top: 15px;
    font-size: 12px;
    color: #B7B2AF;
    border-bottom: 1px solid #eee;
    padding:0 12px 16px;
    height: 86px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .sateCon .conText {
    min-height: 33px;
    margin-bottom: 15px;
  }

  .sateCon .conText span {
    color: #FA6241;
  }

  .stateBtn {
    width: 78px;
    height: 32px;
    line-height: 32px;
    margin-right: 8px;
  }

  /* 备注 */
  .remasks {
    font-size: 12px;
    color: #D1D1D1;
    margin-top: 12px;
    padding:0 12px 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    /* 自动换行，防止过长数字不换行的情况 */
    word-wrap:break-word;
  }
</style>
